// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item_e147dff3 {
  cursor: pointer;
  padding: 0 1.334rem;
  font-family: PitchBookFont, 'Helvetica', 'Arial', sans-serif;
  font-size: 1rem;
  line-height: 1;
  letter-spacing: normal;
  font-stretch: normal;
  height: 2.667rem;
  border: 0.084rem solid transparent;
  background-color: transparent;
  margin: 0;
  white-space: nowrap;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 2.667rem;
}
.item_e147dff3.item__highlighted_e147dff3 {
  color: #fff;
  background-color: #1d5080;
  border-color: #1d5080;
}
.item_e147dff3.item__highlighted_e147dff3 + .separated_e147dff3 {
  border-color: transparent;
}
.item_e147dff3.item__highlighted_e147dff3 .caption_e147dff3 {
  font-weight: 600;
}
.item_e147dff3.item__highlighted_e147dff3 .menu-item-meta_e147dff3 {
  color: inherit;
}
.item_disabled_e147dff3 {
  cursor: default;
  color: #c1c8cd;
  background-color: #eaedef;
  border-color: transparent;
}
.item_disabled_e147dff3 .caption_e147dff3 {
  font-weight: 400;
}
.item_disabled_e147dff3 .menu-item-meta_e147dff3 {
  color: inherit;
}
.item_disabled_e147dff3:focus,
.item_disabled_e147dff3:active,
.item_disabled_e147dff3:hover {
  cursor: default;
  color: #c1c8cd;
  background-color: #eaedef;
  border-color: transparent;
}
.item_disabled_e147dff3:focus .caption_e147dff3,
.item_disabled_e147dff3:active .caption_e147dff3,
.item_disabled_e147dff3:hover .caption_e147dff3 {
  font-weight: 400;
}
.item_disabled_e147dff3:focus .menu-item-meta_e147dff3,
.item_disabled_e147dff3:active .menu-item-meta_e147dff3,
.item_disabled_e147dff3:hover .menu-item-meta_e147dff3 {
  color: inherit;
}
.selected_e147dff3 {
  background-color: #eaedef;
}
.separator_e147dff3 {
  border: none;
  border-top: 1px solid #dce1e5;
  margin: 0;
}
.caption_e147dff3 {
  position: relative;
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  min-width: 0;
}
.caption_e147dff3::before {
  content: attr(data-hover);
  font-weight: 600;
  visibility: hidden;
}
.caption_e147dff3 > span {
  position: absolute;
  left: 0;
  top: 0;
}
.icon_e147dff3 {
  margin-right: 0.667rem;
  position: relative;
  line-height: 1;
  white-space: nowrap;
}
.icon_e147dff3.right_e147dff3 {
  margin-right: 0;
  margin-left: 0.667rem;
}
.list_e147dff3 {
  padding: 0.334rem 0;
}
.floating_e147dff3 {
  display: grid;
  grid-template-rows: 1fr;
}
.menu-item-meta_e147dff3 {
  margin-left: 1.334rem;
  color: #84919b;
  text-transform: uppercase;
  white-space: nowrap;
}
.menu-item-meta_e147dff3 + .menu-item-meta_e147dff3 {
  text-align: right;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `item_e147dff3`,
	"item__highlighted": `item__highlighted_e147dff3`,
	"separated": `separated_e147dff3`,
	"caption": `caption_e147dff3`,
	"menu-item-meta": `menu-item-meta_e147dff3`,
	"item_disabled": `item_disabled_e147dff3`,
	"selected": `selected_e147dff3`,
	"separator": `separator_e147dff3`,
	"icon": `icon_e147dff3`,
	"right": `right_e147dff3`,
	"list": `list_e147dff3`,
	"floating": `floating_e147dff3`
};
export default ___CSS_LOADER_EXPORT___;
